import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowLeft, MapPin, Star } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './Stays.css'; // Reusing the gallery styling since it's exactly what we need

const Journal = () => {
  const navigate = useNavigate();
  const [places, setPlaces] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulated fetch for India Tours
    setLoading(true);
    setTimeout(() => {
      setPlaces([
        { _id: 'p1', name: 'Taj Mahal', state: 'Agra, UP', rating: 5.0, img: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' },
        { _id: 'p2', name: 'Hawa Mahal', state: 'Jaipur, Rajasthan', rating: 4.8, img: 'https://lh3.googleusercontent.com/gps-cs-s/AHVAweoAvRlYpATzsTXoYbnLSdOQNIySBDQAn3JBOZkyC7c3jBZnTKy4L5iGXVLQFFS-Z3TrxjUOFjcr7znmpRsP3p5lDmf34AfIBpYtz9JB5niph1v6aOmrTkNO5X44ohalSzTz-bHObA=s680-w680-h510-rw' },
        { _id: 'p3', name: 'Backwaters', state: 'Alleppey, Kerala', rating: 4.9, img: 'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' },
        { _id: 'p4', name: 'Gateway of India', state: 'Mumbai, MH', rating: 4.7, img: 'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' },
        { _id: 'p5', name: 'Varanasi Ghats', state: 'Varanasi, UP', rating: 4.8, img: 'https://images.unsplash.com/photo-1561361513-2d000a50f0dc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' },
        { _id: 'p6', name: 'Golden Temple', state: 'Amritsar, Punjab', rating: 4.9, img: 'https://www.whyweseek.com/wp-content/uploads/2020/01/facebook-amritsar.jpg' },
        { _id: 'p7', name: 'Red Fort', state: 'Delhi', rating: 4.8, img: 'https://images.unsplash.com/photo-1587474260584-136574528ed5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' },
        { _id: 'p8', name: 'Mysore Palace', state: 'Mysore, Karnataka', rating: 4.9, img: 'https://lh3.googleusercontent.com/gps-cs-s/AHVAweoPOB0eXJ8H-HbgroEuPCh79yjG4dApk81zNZknp287rSEj167Yn0RxbJ4w-ZQPwMaruNBvG5b3iE1DC1d1U46UFWK_-SNN30E3vUB2B59HETMoIOrHhZSEP1yw407bWBdJ_7tJzw=s680-w680-h510-rw' },
        { _id: 'p9', name: 'Meenakshi Temple', state: 'Madurai, TN', rating: 4.9, img: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' },
        { _id: 'p10', name: 'Victoria Memorial', state: 'Kolkata, WB', rating: 4.7, img: 'https://images.unsplash.com/photo-1558431382-27e303142255?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' },
        { _id: 'p11', name: 'Charminar', state: 'Hyderabad, TS', rating: 4.7, img: 'https://lh3.googleusercontent.com/gps-cs-s/AHVAwepYqv47SSs0N_pn6YP-DehMmakPTyMwYU1o8-c9APzQ3k1sc99tLW0QU3BV7nBCr-ncxsh7o6R_bwiP4bgbAO9tlA-qikX5i59gG6mbLlRhkA0aw1PuR2IALbfY4rPMrkpKqvhHVQ=s680-w680-h510-rw' },
        { _id: 'p13', name: 'Ajanta Caves', state: 'Maharashtra', rating: 4.8, img: 'https://lh3.googleusercontent.com/gps-cs-s/AHVAwepdjEatOfqwuSkV2fdu_QWdH3MGLDFaR-TcHYhkNf_wjJiRgCWbR1k_fXN-AdYUyF6AUDpImEtQUVIqgr8_tZ6BAdXC4MNZo9Z7t_KWx9tuSY2tho2bylnpeDt5hxkRYwMXFSTv=s680-w680-h510-rw' },
        { _id: 'p14', name: 'Pangong Lake', state: 'Ladakh', rating: 5.0, img: 'https://static.toiimg.com/photo/92360678.cms' },
      ]);
      setLoading(false);
    }, 600);
  }, []);

  return (
    <div className="stays-page" style={{ background: '#020617' }}>
      <header className="stays-header">
        <button className="back-btn-pill-st" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> <span>Back</span>
        </button>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="header-content-st">
          <h1>Iconic <span className="highlight-text-st">India Tours</span></h1>
          <p>Discover the most legendary tourist places across the subcontinent.</p>
        </motion.div>
      </header>

      <section className="stays-grid-container">
        {loading ? (
          <div className="loading-state-st">Mapping tourist destinations...</div>
        ) : (
          <div className="stays-grid">
            <AnimatePresence>
              {places.map((item, index) => (
                <motion.div
                  key={item._id || index}
                  className="stay-card-st"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                >
                  <img src={item.img} alt={item.name} />
                  <div className="stay-overlay-st">
                    <span className="location-tag-st"><MapPin size={14} /> {item.state}</span>
                    <h3>{item.name}</h3>
                    <div className="rating-display-st">
                      <Star size={14} className="star-icon-st" fill="#fcd34d" color="#fcd34d" /> {item.rating}
                    </div>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        )}
      </section>
    </div>
  );
};

export default Journal;
